import { SortOrders, SortByFields } from '@skeleton/consts/sort';

import type { ISortOption } from '@skeleton/core/types';

export type SortOptionType = 'providers' | 'default' | 'games';

export const useSortingOptions = async (typeSortOption: SortOptionType = 'default') => {
  const { getContent } = useProjectMethods();
  const gamesContentStore = useGamesContentStore();
  const { content: gamesContent } = storeToRefs(gamesContentStore);

  const options = computed<Record<string, ISortOption>>(() => {
    return {
      default: {
        name: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.default'
        ),
        value: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.default'
        ),
        sortBy: SortByFields.DEFAULT,
        sortOrder: SortOrders.ASC,
      },
      mostPopular: {
        name: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.mostPopular'
        ),
        value: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.mostPopular'
        ),
        sortBy: SortByFields.POPULARITY,
        sortOrder: SortOrders.ASC,
      },
      sortOptionsAz: {
        name: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.az'
        ),
        value: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.az'
        ),
        sortBy: SortByFields.NAME,
        sortOrder: SortOrders.ASC,
      },
      sortOptionsZa: {
        name: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.za'
        ),
        value: getContent(
          gamesContent?.value?.currentLocaleData,
          gamesContent?.value?.defaultLocaleData,
          'sortOptions.za'
        ),
        sortBy: SortByFields.NAME,
        sortOrder: SortOrders.DESC,
      },
    };
  });

  const sortOptions = computed<ISortOption[]>(() => {
    switch (typeSortOption) {
      case 'providers':
      case 'games':
      case 'default':
        return Object.values(options.value);
      default:
        return Object.values(options.value);
    }
  });

  const selectedOption = (sortBy?: string, sortOrder?: string): ISortOption => {
    if (sortBy && sortOrder) {
      const foundOption = sortOptions.value.find(option => option.sortBy === sortBy && option.sortOrder === sortOrder);
      return foundOption || sortOptions.value[0];
    }

    return sortOptions.value[0];
  };

  const parseSortQuery = (query: Record<string, any>) => {
    const foundOption = sortOptions.value.find(
      option => option.sortOrder === query.sortOrder && option.sortBy === query.sortBy
    );

    if (foundOption) {
      return {
        sortOrder: foundOption.sortOrder,
        sortBy: foundOption.sortBy,
      };
    }

    return {
      sortOrder: sortOptions.value[0]?.sortOrder || SortOrders.ASC,
      sortBy: sortOptions.value[0]?.sortBy || SortByFields.NAME,
    };
  };

  return { options, sortOptions, selectedOption, parseSortQuery };
};
